import { render } from "./usrinquire_show.vue?vue&type=template&id=1bc0b4d6&scoped=true"
import script from "./usrinquire_show.vue?vue&type=script&lang=js"
export * from "./usrinquire_show.vue?vue&type=script&lang=js"

import "./usrinquire_show.vue?vue&type=style&index=0&id=1bc0b4d6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc0b4d6"]])

export default __exports__